<template>
	<vx-card class="packs" title="Packs">
    	<section>
    		<div class="d-flex justify-content-end">
    			<vs-button
		            class="d-flex justify-content-center align-items-center mr-3"
		            color="success"
		            @click="$router.push({name: 'packs-crear'})"
		            >
		            <feather-icon
			            icon="PlusIcon"
			            svgClasses="stroke-current"
			            class="mr-2"
			            @click.stop="deleteData(tr)"
			          />

		            Registrar pack

		        </vs-button>
    		</div>
    	</section>

    	<div class="text-center" v-if="loading">
    		<p>Cargando...</p>
    	</div>

    	<section class="packs__items mt-5" v-else>
    		<article class="pack" v-for="(item, index) in items" :key="index">

    			<section class="pack__imagen" v-bind:style="{backgroundImage: 'url(' + item.foto_real.url + ')'}"></section>

    			<section class="pack__contenido">
    				<h2 class="subtitulo">{{ item.nombre }}</h2>

    				<p class="small">
    					{{ item.descripcionCorta }}
    				</p>

    				<p>
    					<span>Tipo de entrega:</span>
    					<span class="d-inline-block ml-2">{{ setTipoEntrega(item) }}</span>
    				</p>
    			</section>

    			<section class="d-flex justify-content-end mt-3">
    				<vs-button
			            class="custom-btn d-flex justify-content-center align-items-center mr-3"
			            color="danger"
			            @click="abrirModal(item)"
			            >
			            <feather-icon
				            icon="DeleteIcon"
				            svgClasses="stroke-current"
				            class="mr-1"
				            @click.stop="abrirModal(item)"
				          />
			            </vs-button
			          >

			         <vs-button
			            class="custom-btn d-flex justify-content-center align-items-center mr-3"
			            color="primary"
			            @click="$router.push({name: 'packs-editar', params: {slug: item.slug}})"
			            >
			            <feather-icon
				            icon="EditIcon"
				            svgClasses="stroke-current"
				            class="mr-1"
				            @click="$router.push({name: 'packs-editar', params: {slug: item.slug}})"
				          />
			            </vs-button
			          >

    				<!-- <vs-button
			            class="custom-btn d-flex justify-content-center align-items-center mr-3"
			            color="primary"
			            @click="registrar()"
			            >
			            <feather-icon
				            icon="InfoIcon"
				            svgClasses="stroke-current"
				            class="mr-1"
				          />
			            </vs-button
			          > -->
    			</section>	
    		</article>
    	</section>

    	<vs-popup
	      :title="itemSeleccionado.nombre"
	      :active.sync="modalEliminar"
	      v-if="itemSeleccionado"
	    >
	      <section class="text-center">
	        <p class="mb-3">¿Está seguro de eliminar?</p>

	        <div>
	          <vs-button
	            class="mr-3"
	            color="danger"
	            type="flat"
	            @click="closeModal()"
	            >Cancelar</vs-button
	          >
	          <vs-button
	            color="success"
	            type="filled"
	            @click.prevent="eliminar()"
	            >{{ eliminando ? "Eliminando" : "Eliminar" }}</vs-button
	          >
	        </div>
	      </section>
	    </vs-popup>
 	</vx-card>
</template>

<script>
	import GetAllCombo from '@/apollo/queries/packs/GetAllCombo.gql'
	import DeleteCombo from '@/apollo/mutations/packs/DeleteCombo.gql'

	export default {
		data() {
			return {
				number_paginate: 10,
				page: 1,
				estado: '1',
				nroTotalItems: 0,
				items: [],
				loading: true,
				itemSeleccionado: null,
				modalEliminar: false,
				eliminando: false
			}
		},
		mounted() {
			this.getItems()
		},
		methods: {
			async getItems() {
				let { number_paginate, page, estado } = this

				const res = await this.$apollo.query({
					query: GetAllCombo,
					fetchPolicy: 'no-cache',
					variables: {
						number_paginate,
						page,
						estado
					}
				})

				this.nroTotalItems = res.data.GetAllCombo.NroItems
				this.items = res.data.GetAllCombo.data

				this.loading = false
			},
			abrirModal(item) {
		      this.modalEliminar = true;

		      this.itemSeleccionado = item;
		    },
		    closeModal() {
		      this.modalEliminar = false;

		      this.itemSeleccionado = null;
		    },
		    eliminar() {
		    	this.eliminando = true;

			      this.$apollo
			        .mutate({
			          mutation: DeleteCombo,
			          variables: {
			            combo_id: parseInt(this.itemSeleccionado.id)
			          },
			        })
			        .then(() => {
			          this.eliminando = false;

			          this.modalEliminar = false;

			          this.itemSeleccionado = null;

			          this.getItems();
			        });
		    },
		    setTipoEntrega(item) {
		    	let valor = ''

		    	if(item.tipoEntrega === 1) {
		    		valor = 'Envío gratuito'
		    	} else if(item.tipoEntrega === 2) {
		    		valor = 'Costo de envío asignado'
		    	} else {
		    		valor = 'No asignado'
		    	}

		    	return valor
		    }
		}
	}
</script>

<style lang="scss">
.packs {
	&__items {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 2rem;
	}

	.vs-button-text.vs-button--text {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

.pack {
	&__imagen {
		height: 200px;
	}
}
</style>